import React, { Component } from 'react'
import { Box, Text, Button } from 'grommet';
import PropTypes from 'prop-types';
import { loader, maskCardNumber } from '../Utils/Utility';
/*import ReactToPrint from 'react-to-print';*/


export default class ReportStep2 extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    /* Useless since we are not using "this"
    constructor(props) {
        super(props);
    }*/

    printpage() {
        var restorePage = document.body.innerHTML;
        var prtheader = document.getElementById("header").innerHTML;
        var prtContent = document.getElementById("contentResume").innerHTML;
        var prtfooter = document.getElementById("footer").innerHTML;
        document.body.innerHTML = prtheader + "<div  style='margin-top=60px'>" + prtContent + '</div>' + prtfooter;
        window.print();
        document.body.innerHTML = restorePage;
    }

    render() {
        const riepilogo = this.props.values.dataReport === undefined || (Array.isArray(this.props.values.dataReport) && this.props.values.dataReport.length === 0)  ? [] : this.props.values.dataReport;
        const codiceEs = sessionStorage.getItem('code') === "" && sessionStorage.getItem('codepos') !== "" ? sessionStorage.getItem('codepos') : sessionStorage.getItem('codepos') === "" && sessionStorage.getItem('code') !== "" ? sessionStorage.getItem('code') : "-";

        return (

            <Box id='contentResume' className='contentbox' ref={el => (this.componentRef = el)}>

                <Box align='start' style={{ margin: '20px 22px ' }}>
                    <Text className='titlehome'>Report Dispute  </Text>

                </Box>
                <Box alignContent='center' margin='small'>
                    {this.props.values.loading ? 
                        loader
                    : 
                    <Box>  
                        <Box id='reportResume' >
                            <Box direction='row' style={{ marginBottom: '30px' }}>
                                <Box style={{ width: '30%', textAlign: 'left' }}>
                                    <Text>Codice esercente:</Text>
                                    <Text>Data:</Text>
                                    <Text>Numero Carta:</Text>
                                    <Text>Gestore: </Text>
                                    <Text>Pratiche totali:</Text>
                                </Box>
                                <Box style={{ width: '70%', textAlign: 'left' }}>
                                    <Text> {codiceEs}</Text>
                                    <Text>dal {this.props.values.startDateOut === '' ? '-' : this.props.values.startDateOut} al {this.props.values.endDateOut === '' ? '-' : this.props.values.endDateOut}</Text>
                                    <Text> {this.props.values.numCarta === '' ? '-' : maskCardNumber(this.props.values.numCarta)}</Text>
                                    <Text> {riepilogo !== [] && (riepilogo.ebox === '' || riepilogo.length === 0) ? '-' : riepilogo.ebox}</Text>
                                    <Text> {riepilogo !== [] && riepilogo.totalPractices === '' ? '-' : riepilogo.totalPractices} </Text>
                                </Box>
                            </Box>
                        </Box>
                        <Box >
                            <Box direction='row' style={{ marginBottom: '30px' }}>
                                <Box style={{ width: '30%', textAlign: 'left' }} >
                                    <Text>Nuove:</Text>
                                    <Text>In sospeso: </Text>
                                    <Text>In scadenza: </Text>
                                </Box>
                                <Box style={{ width: '70%', textAlign: 'left' }} >
                                    <Text>{riepilogo !== [] && riepilogo.new === '' ? '0' : riepilogo.new}</Text>
                                    <Text>{riepilogo !== [] && riepilogo.suspended === '' ? '0' : riepilogo.suspended}</Text>
                                    <Text>{riepilogo !== [] && riepilogo.expiring === '' ? '0' : riepilogo.expiring}</Text>
                                </Box>
                            </Box>
                            <Box direction='row' style={{ marginBottom: '30px' }}>
                                <Box style={{ width: '30%', textAlign: 'left' }} >
                                    <Text>In visione:</Text>

                                </Box>
                                <Box style={{ width: '70%', textAlign: 'left' }} >
                                    <Text>{riepilogo !== [] && riepilogo.viewed === '' ? '0' : riepilogo.viewed}</Text>
                                </Box>
                            </Box>
                            <Box direction='row' style={{ marginBottom: '30px' }}>
                                <Box style={{ width: '30%', textAlign: 'left' }} >
                                    <Text>Annullate:</Text>
                                    <Text>Evase:</Text>
                                    <Text>Scadute:</Text>
                                    <Text>Chiuse:</Text>
                                </Box>
                                <Box style={{ width: '70%', textAlign: 'left' }} >
                                    <Text>{riepilogo !== [] && riepilogo.canceled === '' ? '0' : riepilogo.canceled}</Text>
                                    <Text>{riepilogo !== [] && riepilogo.completed === '' ? '0' : riepilogo.completed}</Text>
                                    <Text>{riepilogo !== [] && riepilogo.expired === '' ? '0' : riepilogo.expired}</Text>
                                    <Text>{riepilogo !== [] && riepilogo.closed === '' ? '0' : riepilogo.closed}</Text>
                                </Box>
                            </Box>
                            <Box align='center' margin='medium'>
                                <Box direction='row' gap='large'>
                                    <Box ><Button className='btnform' onClick={this.props.prevStep} >Nuova ricerca</Button></Box>
                                    <Box ><Button className='btnform' onClick={this.printpage}>Stampa</Button></Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    }
                </Box>
            </Box>
        )
    }
}
